require('!!raw-loader!/builds/761759/v2/src/index.html');